<template>
    <div>
        <validation-provider
                :name="field.name"
                :rules="field.rules"
                v-slot="validationContext"
        >
            <b-form-group
                    :label-for="field.name"
                    :label="field.label + '\xa0'"
                    :id="'g_' + field.name"
                    class="m-md-0"
            >
                <b-form-input
                        :placeholder="field.placeholder"
                        v-model="data.value"
                        :id="field.name"
                        :state="getValidationState(validationContext)"
                        :aria-describedby="'input-2-live-feedback' + field.name"
                        data-placement="top"
                        :title="field.label"
                        :disabled="field.readonly"

                ></b-form-input>
                <small v-if="field.hint" class="text-info">{{field.hint}}</small>
                <h6 class="text-right">{{field.textAfter}}&#8288;</h6>
                <b-form-invalid-feedback
                        :id="'input-2-live-feedback' + field.name"
                >{{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
            </b-form-group>
        </validation-provider>
    </div>
</template>

<script>
    export default {
        name: "TextInput",
        props: {
            field: { required: true},
            data: { required: true },
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        }

    }
</script>

<style scoped>

</style>
